import type { NextPage } from 'next'
import styles from './CommunityComponent.module.scss'
import { Community } from 'types/community'
import { useRouter } from 'next/navigation'
import { Activity } from 'types/user'
import EntryComponentContainer from '../../entryComponentContainer'
import { deleteCommunity } from 'actions/community'
import { flagPost } from 'actions/post'
import { useState, useEffect } from 'react'
import { Option } from 'types/options'
import { deleteEvent } from 'actions/event'
import { useAppSelector, useAppDispatch } from 'reducers/storeHooks'

interface Props {
  community: Community
  activity: Activity
  showorganiser?: boolean
  entryId: string
}

const CommunityComponent: NextPage<Props> = (props: Props) => {
  const community = props.community
  const router = useRouter()
  const uid = useAppSelector((state) => state.userReducer.user?.uid)
  const dispatch = useAppDispatch()


  const [options, setOptions] = useState<Option[]>([]);


  useEffect(() => {
    if (community?.uid === uid) {
      setOptions([
        {
          label: "Delete",
          onClick: () => {
            confirm("Are you sure you want to delete this community?") && dispatch(deleteCommunity(props.entryId))
          }
        }
      ])
    } else {
      setOptions([

        {
          label: "Flag",
          onClick: () => { confirm("Are you sure you want to flag this community?") && dispatch(flagPost(props.entryId)) }
        }
      ])

    }
  }, [])

  if (!community) {
    return <div>Loading</div>
  }
  const goToProfile = (uid: string) => {
    router.push('./profile?uid=' + uid)
  }

  const goToCommunity = (e: React.MouseEvent) => {
    e.stopPropagation();
    router.push('./community?eid=' + props.entryId)
  }

  return (
    <EntryComponentContainer
      type="COMMUNITY"
      options={options}
    >
      <div className={styles.container}>
        <div className={styles.imageWrapper} onClick={goToCommunity}>
          <img src={community.image} className={styles.image} />
        </div>
        <div className={styles.infoWrapper}>
          <div className={styles.main_side}>
            <div className={styles.title}>{community.title}</div>
            <div className={styles.subtitle}>{community.description}</div>
            {props.showorganiser && (
              <div className={styles.subtitle} onClick={() => goToProfile(community.uid)} >
                Check organiser
              </div>
            )}
          </div>
        </div>
      </div>
    </EntryComponentContainer>
  )
}

export default CommunityComponent
